import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
    Button,
    Field,
    Toast,
    CellGroup,
    Cell,
    Popup,
    Picker,
    Icon,
    Progress,
    Circle,
    ShareSheet,
    Uploader,
    Tab,
    Tabs,
    Sticky,
    Loading,
    Divider,
    ImagePreview,
    Sidebar,
    SidebarItem,
    List,
    DatetimePicker,
    Dialog,
    Tag,
    Form,
    RadioGroup,
    Radio,

    Switch,
    Checkbox,
    CheckboxGroup,
    Stepper,
    Rate,
    Cascader,
    TreeSelect,
    Empty,
} from 'vant'

import 'vant/lib/index.css'
import '@vant/touch-emulator'

Vue.config.productionTip = false
Vue.use(Button)
Vue.use(Field)
Vue.use(Toast)
Vue.use(CellGroup)
Vue.use(Cell)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Icon)
Vue.use(Progress)
Vue.use(Circle)
Vue.use(ShareSheet)
Vue.use(Uploader)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Sticky)
Vue.use(Loading)
Vue.use(Divider)
Vue.use(ImagePreview)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(List)
Vue.use(DatetimePicker)
Vue.use(Dialog)
Vue.use(Tag)
Vue.use(Form)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Switch)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Stepper)
Vue.use(Rate)
Vue.use(Cascader)
Vue.use(TreeSelect)
Vue.use(Empty)

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
